<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="nama barang..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal Pembelian" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="form-group mb-0">
                    <multiselect v-model="searchStatus" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                        label="value" track-by="name" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0 mr-1">
                    <multiselect v-model="searchKesediaan" :options="kesediaanOptions" :placeholder="'Pilih kesediaan'" :searchable="true"
                        label="value" track-by="name" :show-labels="false" :allowEmpty="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

export default {
    components: {
        Multiselect,
        DatePicker,
    },

    data() {
        return {
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchKesediaan: {
                'name': 'tersedia',
                'value': 'Tersedia',
            },
            statusOptions: [
                {
                    name: 'terjual',
                    value: 'Terjual',
                },
                {
                    name: 'hilang',
                    value: 'Hilang',
                },
                {
                    name: 'rusak',
                    value: 'Rusak',
                },
            ],
            kesediaanOptions: [
                {
                    'name': 'tersedia',
                    'value': 'Tersedia',
                },
                {
                    'name': 'terhapus',
                    'value': 'Terhapus',
                },
                {
                    'name': '',
                    'value': 'Semua',
                },
            ],
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDate : null,
                    searchStatus: self.searchStatus ? self.searchStatus.name : '',
                    searchKesediaan: self.searchKesediaan ? self.searchKesediaan.name : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchKesediaan = Object.assign({}, {
                'name': 'tersedia',
                'value': 'Tersedia',
            });
            this.$emit('search-reset');
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
